var EventEmitterMixin = require("../../mixins/event-emitter.mixin");
var recaptchaFactory = require("./recaptcha-factory.service");

var RecaptchaPopUpComponent = function () {
    var self = this;
    var $currentContext = $();
    var moduleOptions = {
        id: "",
        publicKey: ""
    };

    var $modal;
    var recaptcha;

    this.show = function() {
        $modal.modal("show");

        if(!recaptcha) {
            var $recaptchaContext = $(`.js-recaptcha--${moduleOptions.id}`, $currentContext);
            recaptchaFactory.create($recaptchaContext, moduleOptions.publicKey,
                    (gResponse) => self._raiseEvent("recaptcha-validated", gResponse)
                )
                .then(x => recaptcha = x);
        }
    }

    this.hide = function() {
        $modal.modal("hide");

        recaptcha.reset();
    }

    function bindEvents() {
        $modal = $currentContext;
        $modal.on("hidden.bs.modal", () => recaptcha.reset());
    }

    function parseContext() {
    }

    this.init = function ($context, options) {
        $currentContext = $context || $currentContext;
        $.extend(moduleOptions, options);

        parseContext();
        bindEvents();
    };
};

Object.assign(RecaptchaPopUpComponent.prototype, new EventEmitterMixin());

Object.defineProperty(RecaptchaPopUpComponent, "SELECTOR", {
    enumerable: false,
    configurable: false,
    writable: false,
    value: ".js-recaptcha-popup"
});

module.exports = RecaptchaPopUpComponent;
